import * as React from "react";
import type { SVGProps } from "react";
const SvgHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#heart_svg__a)">
      <path
        fill="currentColor"
        d="M12 21a1 1 0 0 1-.7-.29L3.81 13.3A6 6 0 0 1 12 4.54a6 6 0 0 1 8.79 8.09 6 6 0 0 1-.6.67.2.2 0 0 1-.07.07l-7.42 7.35a1 1 0 0 1-.7.28m-6.79-9.13L12 18.6l6.8-6.73.07-.06q.18-.18.33-.39a4 4 0 0 0-6.4-4.8A1.13 1.13 0 0 1 12 7a1 1 0 0 1-.8-.41q-.195-.255-.42-.48a4.006 4.006 0 0 0-5.57 5.76"
      />
    </g>
    <defs>
      <clipPath id="heart_svg__a">
        <path fill="#fff" d="M2 3h20v18.01H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHeart;
